import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AccountProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CompletePhoneView"] */ "/app/src/components/auth/complete-phone-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SupportWidget.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/layouts/dashboard/layout.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/layouts/dashboard/main.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PermissionProvider"] */ "/app/src/lib/rbac/PermissionContext.tsx");
